import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Hallintapaneeli',
  tabs: {
    [tabs.general]: 'Yleinen',
    [tabs.overview]: 'Yleiskatsaus',
    [tabs.orders]: 'Tilaukset lähteen mukaan',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Asiakkaat',
    [tabs.order_conversion]: 'Tilauskonversio',
    [tabs.mobile_app]: 'Mobiilisovellus',
  },
  date_range: {
    this_month: 'Tämä kuukausi',
    last_month: 'Viime kuukausi',
    last_week: 'Viime viikko',
    this_week: 'Tämä viikko',
    this_year: 'Tämä vuosi',
    last_year: 'Viime vuosi',
    today: 'Tänään',
    yesterday: 'Eilen',
    all: 'Kaikki',
  },
  buttons: {
    view_key_info: 'Näytä keskeiset tiedot',
  },
  empty_franchise: {
    description: 'Tällä brändillä ei ole vielä ravintolaa. Valitse toinen brändi valikosta nähdäksesi sen luvut.',
  },
};
